
(function documentControllerDefinition() {
    'use strict';

    angular.module('Document')
        .controller('DocumentAddMultipleDigitalizedController', [
            '$scope', 'config', '$state', 'errorsExtend', 'documentService', 'documentTypeService', 'doublyLinkedList',
            'twainCapture', '$q', '$timeout', 'authExtend', 'organizationalUnitService', '$translate', '$filter',
            function documentAddMultipleController($scope, config, $state, errors, documentService, documentTypeService, doublyLinkedList,
                twainCapture, $q, $timeout, authExtend, organizationalUnitService, $translate, $filter) {

                // tamaño del batch de scan
                const batchSize = 5;
                const documentParallelism = 2;
                $scope.finished = true;
                $scope.optionsDocumentTypes = [];
                $scope.metadataAsName = 0;
                $scope.canAddItemsToComboMetadata = authExtend.isInRole('METADATA INSERT');

                $scope.cancel = function () {
                    $state.go('document-add-multiple');
                };

                $scope.aux = {};

                $scope.document = {
                    documentTypes: [],
                    organizationalUnitId: authExtend.getOrganizationId(),
                    isDocumentPerFile: false,
                    hasMoreImages: true, // flag utilizado para el encolado.
                    files: [],
                    deferredMetadataValidation: true
                };

                documentTypeService.getFunctionsTypes(['DOCUMENT WRITE', 'DOCUMENTVERSIONED WRITE']).then(function (result) {
                    $scope.optionsDocumentTypes = result.sort(function (a, b) {
                        return a.name.localeCompare(b.name);
                    });

                    if ($scope.optionsDocumentTypes.length === 1) {
                        $scope.selectDocumentType($scope.optionsDocumentTypes[0]);
                        $scope.aux.selectedDocumentTypeid = $scope.optionsDocumentTypes[0].id;
                    }
                }, function (error) {
                    errors.showError(error);
                    $state.go('document-find');
                });

                $scope.selectDocumentType = function (documentType) {

                    documentTypeService.getById(documentType.id, 'detail')
                        .then(function (result) {

                            var documentDocType = {
                                systemName: documentType.systemName,
                                documentTypeName: result.name,
                                documentTypeId: result.id,
                                metadatas: result.metadata.map(function (metadataDefinition) {

                                    if (metadataDefinition.asName) {
                                        $scope.metadataAsName++;
                                    }

                                    return {
                                        metadataId: metadataDefinition.metadataId,
                                        isIdentifier: metadataDefinition.isIdentifier,
                                        metadataIsRequired: false,
                                        metadataFromBarcode: metadataDefinition.fromBarcode,
                                        metadataFromBarcodeStart: metadataDefinition.fromBarcodeStart,
                                        metadataFromBarcodeLength: metadataDefinition.fromBarcodeLength,
                                        metadataIsUnique: metadataDefinition.isUnique,
                                        metadataLabel: metadataDefinition.metadataLabel,
                                        metadataType: metadataDefinition.metadataType,
                                        metadataSystemName: metadataDefinition.metadataSystemName,
                                        metadataOptions: metadataDefinition.optionValues,
                                        metadataValue: null,
                                        metadataAsName: metadataDefinition.asName,
                                        metadataAttributes: metadataDefinition.attributes,
                                        metadataIsMultivalue: metadataDefinition.isMultivalue,
                                        metadataIsUpdateable: (metadataDefinition.isUpdateable && $scope.canAddItemsToComboMetadata)
                                    };
                                })
                            };

                            $scope.document.documentTypes = [];
                            $scope.document.documentTypes.push(documentDocType);

                        }, function (error) {
                            errors.showError(error);
                            $state.go('document-find');
                        });
                };

                var cancelDeferred = null;
                var documentsQueue = doublyLinkedList();

                $scope.digitalizedFiles = 0;
                $scope.processedFiles = 0;
                $scope.totalDocumentCount = 0;
                $scope.sentDocumentCount = 0;
                $scope.createdDocumentCount = 0;
                $scope.modifiedDocumentCount = 0;
                $scope.fileNameTemplate = 'Imagen Capturada $unique$';
                $scope.barcodeConfig = null;
                $scope.separators = 0;

                function getOuOuConfigMetadataValues(ouOuConfig) {

                    var obj = {};

                    var values = {};

                    angular.forEach(ouOuConfig.metadataValues, function (ouOuConfigMetadataValue) {
                        values[ouOuConfigMetadataValue.organizationalUnitConfigMetadata.id] = ouOuConfigMetadataValue;
                    });

                    angular.forEach(ouOuConfig.organizationalUnitConfig.metadata, function (ouConfigMetadata, key) {
                        obj[ouConfigMetadata.metadata.name] = values[ouConfigMetadata.id].value;
                    });

                    return obj;
                }

                /*
                 * TODO: Obtener la configuración de barcode aca
                 */
                organizationalUnitService.getConfigByName(authExtend.getOrganizationId(), '#BarcodeConfigOuType')
                    .then(function (result) {
                        if (result.length) {

                            var values = getOuOuConfigMetadataValues(result[0]);

                            $scope.barcodeConfig = {
                                defined: true,
                                virtualSeparator: values["#BarcodeIncludeMode"] === '2',
                                includeNoBarcode: values["#BarcodeIncludeMode"] === '1',
                                length: values["#BarcodeLength"] || -1,
                                prefix: values["#BarcodePrefix"] || undefined,
                                type: values["#BarcodeType"] ? parseInt(values["#BarcodeType"]) : twainCapture.BarcodeTypes.All
                            };
                        } else {
                            $scope.barcodeConfig = {
                                defined: false
                            }
                        }
                    }, function (error) {
                        errors.showError(error);
                        $scope.barcodeConfig = {
                            defined: false
                        }
                    });


                /*
                 * Retornará true si la imagen con el indice especificado tiene los mismos barcodes que los especificados.
                 */
                function isSameDocument(compareBarcodeData, index) {

                    if ($scope.barcodeConfig.defined) {

                        var deferred = $q.defer();

                        // tengo que comparar con el barcode info del documento.
                        twainCapture.readBarcodes(index, $scope.barcodeConfig)
                            .then(function (barcodeData) {

                                if ($scope.barcodeConfig.virtualSeparator) {
                                    if (barcodeData.length === 1
                                        && (barcodeData[0].type & $scope.barcodeConfig.type) !== 0
                                        && barcodeData[0].content === $scope.barcodeConfig.prefix) {
                                        // cuando se lee el virtual separator entonces se ignora la 
                                        // página y se cambia de documento.
                                        return deferred.resolve({ same: false, ignore: true });
                                    } else {
                                        return deferred.resolve({ same: true, barcodeFound: true });
                                    }
                                }

                                var ret = true;

                                if (compareBarcodeData != null && compareBarcodeData.length) {
                                    if (barcodeData.length === 0) {
                                        // NO tiene barcode y el documento sí tenía.
                                        ret = $scope.barcodeConfig.includeNoBarcode;
                                    }
                                    else if (compareBarcodeData.length !== barcodeData.length) {
                                        // Ambos tienen barcode y no coinciden.
                                        ret = false;
                                    } else {

                                        for (var i = 0; i < barcodeData.length; i++) {

                                            if (compareBarcodeData[i].content !== barcodeData[i].content
                                                || compareBarcodeData[i].type !== barcodeData[i].type) {
                                                ret = false;
                                                break;
                                            }
                                        }
                                    }
                                } else {
                                    /*
                                     * Si compareBarcodeData es null entonces los documentos anteriores no tenian 
                                     * barcodes, con lo cual si este sí tiene, no es del mismo doc.
                                     */
                                    ret = (barcodeData.length === 0);
                                }

                                return deferred.resolve({
                                    same: ret,
                                    barcodeFound: barcodeData.length !== 0,
                                    barcodeData: barcodeData
                                });

                            }, function (errorCode) {
                                errors.showError($translate.instant('DocumentBarcodeReadError', { errorCode: errorCode }));
                                deferred.reject();
                            });

                        return deferred.promise;

                    } else {
                        // No se distinguen pues no hay configuración de barcodes para distinguir.
                        return $q.resolve({ same: false, barcodeFound: true });
                    }
                }

                /*
                 * Mostrará el mensaje de fin si no hay mas documento y se terminó la digitalización
                 */
                function showFinishedMessage() {
                    if (!$scope.digitalizing
                        && $scope.digitalizedFiles === $scope.processedFiles
                        && ($scope.createdDocumentCount + $scope.modifiedDocumentCount) == $scope.totalDocumentCount) {
                        errors.showSuccess('DocumentDigitalizationFinished');
                    }
                }

                /*
                 * Setea el nombre del documento en base a un metadato marcado como "asName" (si lo hay)
                 */
                function setNameFromMetadata(document) {

                    var docTypes = document.documentTypes;

                    for (var i = 0; i < docTypes.length; i++) {
                        var docDocType = docTypes[i];

                        var m = docDocType.metadatas.find(function (metadata) {
                            return metadata.metadataAsName;
                        });

                        if (m && m.metadataValue) {
                            document.name = m.metadataValue;
                            break;
                        }
                    }
                }

                /*
                 * Envía los documentos de la cola a la API si
                 * la cantidad de documentos siendo creados es menor a documentParallelism
                 */
                function sendPendingDocuments() {

                    if (documentsQueue.size()) {

                        var document = documentsQueue.first();

                        // me fijo si hay documentos para envíar (pushingFiles = 0 y hasMoreImages = false)
                        if ($scope.sentDocumentCount < documentParallelism
                            && document.pushingFiles === 0
                            && !document.hasMoreImages) {

                            documentsQueue.dequeue();

                            if (document.files.length) {

                                // envío el documento
                                $scope.sentDocumentCount++;

                                if ($scope.metadataAsName) {
                                    setNameFromMetadata(document);
                                }

                                var promise = null;

                                if (document.id) {

                                    var allFiles = document.files;
                                    var files = [];
                                    document.files = [];

                                    allFiles.forEach(function (file) {
                                        if (file.id) {
                                            document.files.push(file);
                                        } else {
                                            files.push(file);
                                        }
                                    });

                                    promise = documentService.modify(document, files);
                                } else {

                                    var files = document.files;
                                    delete document.files;

                                    promise = documentService.create(document, files);
                                }

                                promise.then(function (resultDocument) {

                                    $scope.sentDocumentCount--;
                                    if (document.id) {
                                        $scope.modifiedDocumentCount++;
                                    } else {
                                        $scope.createdDocumentCount++;
                                    }
                                    $scope.processedFiles += files.length;

                                    $timeout(sendPendingDocuments);

                                }, function (error) {
                                    $scope.stopProcessAndDigitalization(true);
                                    errors.showError(error);
                                });
                            }

                            $timeout(sendPendingDocuments);
                        }

                    } else if (!$scope.sentDocumentCount && !processing) {

                        showFinishedMessage();

                        if (!$scope.digitalizing) {
                            $scope.finished = true;
                        }
                    }
                }

                /*
                 * Retornará true si el documento tiene algún type con metadata fromBarcode
                 */
                function mustMapFromBarcode(document) {
                    return document.documentTypes.some(function (docDocType) {
                        return docDocType.metadatas.some(function (metadata) {
                            return metadata.metadataFromBarcode;
                        });
                    });
                }

                /*
                 * Retornará true si el documento tiene algún type con metadata isIdentifier
                 */
                function hasNonEmptyIdentifiers(document) {
                    return document.documentTypes.some(function (docDocType) {
                        return docDocType.metadatas.some(function (metadata) {
                            return metadata.isIdentifier && metadata.metadataValue;
                        });
                    });
                }

                /*
                 * Retornará un texto con los metadatos identifier y sus valores.
                 */
                function extractIdentifierMetadataLabels(document) {
                    return document.documentTypes.map(function (docDocType) {

                        var metadatas = docDocType.metadatas.map(function (metadata) {
                            return metadata.isIdentifier ? metadata.metadataLabel + '=' + metadata.metadataValue : '';
                        }).filter(function (str) { return str != ""; })
                            .join(', ');

                        if (metadatas != '') {
                            return docDocType.documentTypeName + " [" + metadatas + "]";
                        }

                        return null;

                    }).filter(function (str) { return str != null; })
                        .join(', ');
                }

                /*
                 * Agrega los typos que no están en el documento pero si se seleccionaron.
                 */
                function addMissingTypes(document) {

                    angular.forEach($scope.document.documentTypes, function (docDocType) {

                        if (!document.documentTypes.some(function (ddt) { return ddt.documentTypeId === docDocType.documentTypeId; })) {
                            // agrego el type.
                            document.documentTypes.push(angular.copy(docDocType));
                        }
                    });
                }

                /*
                 * Crea un documento con el primer archivo del buffer.
                 */
                function createDocument(barcodeData) {

                    var newDocument = angular.copy($scope.document);

                    $scope.totalDocumentCount++;

                    var promise = null;

                    if (mustMapFromBarcode($scope.document)
                        && barcodeData
                        && barcodeData.length) {

                        var ret = documentService.mapBarcodeMetadata(newDocument, barcodeData[0].content);

                        if (ret !== true) {
                            return $q.reject($translate.instant('DocumentMetadataMapError', { metadataLabel: ret }));
                        }

                        if (hasNonEmptyIdentifiers(newDocument)) {
                            promise = documentService.findDocumentByIdentifiers(newDocument);
                        } else {
                            promise = $q.when(null);
                        }
                    } else {
                        promise = $q.when(null);
                    }

                    return promise
                        .then(function (documents) {

                            var docPromise = null;

                            if (documents && documents.length) {

                                if (documents.length > 1) {
                                    // FIXME: Por ahora solo tomo el primero.
                                    return $q.reject($translate.instant("DocumentMultipleDocumentsFound", { metadatas: extractIdentifierMetadataLabels(newDocument) }));
                                }

                                // toma el documento.
                                docPromise = documentService.checkout(documents[0])
                                    .then(function (doc) {

                                        doc.barcodeData = barcodeData;
                                        doc.hasMoreImages = true;
                                        doc.deferredMetadataValidation = true;

                                        // mapeo nuevamente los metadatos por si no estaban mapeados en el documento existente.
                                        var ret = documentService.mapBarcodeMetadata(doc, barcodeData[0].content);

                                        if (ret !== true) {
                                            return $q.reject($translate.instant('DocumentMetadataMapError', { metadataLabel: ret }));
                                        }

                                        // si el documento tiene algún type que no está en el guardado se lo agrego.
                                        addMissingTypes(doc);

                                        //Actualizo los metadatos cargados por UI
                                        newDocument.documentTypes.forEach(function (dotype) {
                                            var docDocumentType = $filter('filter')(doc.documentTypes, { documentTypeId: dotype.documentTypeId }, true);
                                            if (docDocumentType.length > 0) {
                                                dotype.metadatas.forEach(function (metadata) {
                                                    if (!metadata.metadataFromBarcode && metadata.metadataValue) {
                                                        var docMetadata = $filter('filter')(docDocumentType[0].metadatas, { metadataId: metadata.metadataId }, true);
                                                        if (docMetadata.length > 0) {
                                                            docMetadata[0].metadataValue = metadata.metadataValue
                                                        } else {
                                                            docDocumentType[0].metadatas.push(metadata);
                                                        }
                                                    }
                                                });
                                            }
                                        });


                                        return $q.resolve(doc);
                                    },
                                    function (error) {

                                        if (error.data && error.data.key === 'CheckedOutError') {
                                            error.data.key = 'MassiveCheckedOutError';
                                            error.data.value = angular.extend(error.data.value, { metadata: extractIdentifierMetadataLabels(newDocument) });
                                        }

                                        return $q.reject(error);
                                    });
                            } else {
                                // Si cae acá es porque no hay documentos existentes con los mismos identificadores.
                                newDocument.barcodeData = barcodeData;

                                docPromise = $q.when(newDocument);
                            }

                            return docPromise
                                .then(function (doc) {

                                    doc.pushingFiles = 1;

                                    newDocument = doc;

                                    documentsQueue.enqueue(newDocument);

                                    return twainCapture.popImageFile($scope.fileNameTemplate).then(function (file) {

                                        if (file) {
                                            if (newDocument.files.length === 0) {
                                                newDocument.name = barcodeData && barcodeData.length ? barcodeData[0].content : file.name;
                                            }

                                            newDocument.files.push(file);
                                        }
                                        newDocument.pushingFiles--;
                                        sendPendingDocuments();
                                    });
                                },
                                function (error) {
                                    return $q.reject(error);
                                });
                        }, function (error) {
                            return $q.reject(error);
                        });
                }

                var processing = false;
                /**
                 * Procesa cada archivo escaneado, verificando si pertenece al mismo documento y agrupandolos.
                 */
                function processImagesBatch(continuation) {

                    if (processing && !continuation) {
                        return $q.when(false);
                    }

                    processing = true;

                    var files = [];

                    var count = twainCapture.imagesCount();

                    var document = documentsQueue.last();

                    if (count) {

                        // Verifico si el archivo pertenece al mismo documento que el documento anterior
                        return isSameDocument(document ? document.barcodeData : null, 0)
                            .then(function (res) {

                                if (document && res.same) {
                                    // es del mismo documento -> 
                                    document.pushingFiles++;

                                    return twainCapture.popImageFile($scope.fileNameTemplate)
                                        .then(function (file) {
                                            if (file) {
                                                document.files.push(file);
                                                sendPendingDocuments();
                                            }
                                            document.pushingFiles--;
                                            return processImagesBatch(true);
                                        });
                                } else {

                                    // el documento anterior no tiene mas imagenes
                                    if (document) {
                                        document.hasMoreImages = false;
                                        sendPendingDocuments();
                                    }

                                    if (res.ignore) {
                                        $scope.processedFiles++;
                                        $scope.separators++;
                                        // hay que ignorar el documento (es el separador virtual)
                                        return twainCapture.deleteFirstImage().then(function () {
                                            // continúo procesando las imagenes del batch
                                            return processImagesBatch(true);
                                        });
                                    } else {
                                        return createDocument(res.barcodeData)
                                            .then(function () {
                                                // continúo procesando las imagenes del batch
                                                return processImagesBatch(true);
                                            }, function (error) {
                                                $scope.stopProcessAndDigitalization(true);
                                                if (error) {
                                                    errors.showError(error);
                                                }
                                                processing = false;
                                                return $q.reject(error);
                                            });
                                    }
                                }

                            }, function (error) {
                                if (error) {
                                    errors.showError(error);
                                }
                                processing = false;
                            });

                    } else {
                        processing = false;

                        if (!$scope.digitalizing && document) {
                            document.hasMoreImages = false;
                            sendPendingDocuments();
                        }

                        return $q.when(false);
                    }
                }

                /**
                 * Digitaliza los archivos.
                 */
                $scope.beginDigitalization = function () {

                    if ($scope.digitalizing) {
                        errors.showError('AlreadyDigitalizing');
                        return;
                    }

                    if (!$scope.documentForm.$valid) {
                        $scope.documentForm.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    if (twainCapture.imagesCount()) {
                        // quedó a la mitad por alguna razón
                        return processImagesBatch(true);
                    }

                    if (!twainCapture.feederLoaded()) {
                        errors.showError('FeederEmpty');
                        return false;
                    }

                    if ($scope.fileNameTemplate.indexOf('$unique$') === -1) {
                        $scope.fileNameTemplate += ' $unique$';
                    }

                    $scope.digitalizedFiles = 0;
                    $scope.totalDocumentCount = 0;
                    $scope.createdDocumentCount = 0;
                    $scope.modifiedDocumentCount = 0;
                    $scope.processedFiles = 0;
                    $scope.separators = 0;

                    cancelDeferred = $q.defer();

                    $scope.digitalizing = true;
                    $scope.captureError = false;
                    $scope.finished = false;

                    return twainCapture.scanBatched(batchSize, cancelDeferred)
                        .then(function () {
                            // se terminó el scan -> si no estoy enviando no muestro aún el cartel.
                            $scope.digitalizing = false;

                            showFinishedMessage();

                            var document = documentsQueue.last();

                            if (document && twainCapture.imagesCount() === 0) {
                                document.hasMoreImages = false;
                            }

                            // Creo los documentos
                            sendPendingDocuments();

                        }, function (error) {
                            if (error) {
                                errors.showError(error);
                            }
                            $scope.digitalizing = false;
                            $scope.captureError = true;
                        }, function (count) {
                            // cada notificación corresponde a un batch de archivos
                            $scope.digitalizedFiles += count;

                            // Creo los documentos
                            processImagesBatch();
                        });
                };

                $scope.stopProcessAndDigitalization = function (error) {

                    if (error) {
                        // limpio la cola de documentos
                        documentsQueue.clear();
                        // limpio las imagenes.
                        twainCapture.clear();
                    }

                    if (cancelDeferred) {
                        cancelDeferred.resolve();   // esto cancela el escaneo.
                    }

                    if (!error) {
                        // si hay imagenes escaneadas todavia, las proceso.
                        processImagesBatch();
                    } else {
                        $scope.finished = true;
                        $scope.totalDocumentCount -= ($scope.createdDocumentCount + $scope.modifiedDocumentCount);
                    }
                };

                $scope.configureDigitalization = function () {
                    twainCapture.showConfigUi();
                };

                $scope.$watch(function () {
                    return twainCapture.isAvailable();
                }, function (val) {
                    $scope.digitalizerNotAvaliable = !val;
                });
            }
        ]);
})();